/** Manifest-only index safe for both server and client bundles. */
export { pocBoardManifest, POC_BOARD_ID } from './poc-board/manifest.ts';
export { pocChoiceManifest, POC_CHOICE_ID } from './poc-choice/manifest.ts';
export { fixtureDiceBoardManifest, FIXTURE_DICE_BOARD_ID } from './fixture-dice-board/manifest.ts';
export { fixtureTeam2v2Manifest, FIXTURE_TEAM_2V2_ID } from './fixture-team-2v2/manifest.ts';
export {
  decisionMakerManifest,
  DECISION_MAKER_ID,
  DecisionMakerAction,
  DecisionMakerConfig,
  DecisionMakerEnding,
  DecisionMakerHistoryEntry,
  DecisionMakerParticipant,
  DecisionMakerPhase,
  DecisionMakerResultPayload,
  DecisionMakerView,
} from './decision-maker/manifest.ts';
export {
  hotPotatoManifest,
  HOT_POTATO_ID,
  HotPotatoAction,
  HotPotatoConfig,
  HotPotatoPhase,
  HotPotatoParticipant,
  HotPotatoResultPayload,
  HotPotatoView,
} from './hot-potato/manifest.ts';

export { momentumBoardManifest, MOMENTUM_BOARD_ID, BOARD_HOP_MS, BOARD_ROLL_MS } from './momentum-board/manifest.ts';
export { momentumBoardV2Manifest, MOMENTUM_BOARD_V2_ID } from './momentum-board-v2/manifest.ts';
/** Every module id whose projection is the immersive ceramic world (drives the immersive shell and berry avatars). */
export const MOMENTUM_WORLD_MODULE_IDS: readonly string[] = ['momentum-board', 'momentum-board-v2'];
